import {Dispatch, FC, SetStateAction, useEffect, useState, useCallback} from 'react'
import {ModalComponent} from '../../../../../../components/Layout/Modal'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {documentByPerson} from '../../../../schema/person'
import {createDocumentByPerson, updateDocumentByPerson} from '../../../../services'
import {DocumentPersonModel} from '../../../../model'
import {useCentral} from '../../../../../../hooks/useCentral'
import {
  SelectWrapper,
  SelectAsyncWrapper,
  InputNumberWrapper,
} from '../../../../../../components/UI/Form/Input'
import {ShowSnackBar} from '../../../../../../util/functions'
import useEnterpriseService, {
  ENTERPRISE_SEARCH_MIN_LENGTH,
} from '../../../../hooks/useEnterpriseService'
import {useTableMaster} from '../../../../hooks'
import {SUCCESS_MESSAGE_UPDATE, SUCCESS_MESSAGE_CREATE} from '../../../../../../util/Constants'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  getDocumentPersonList: () => void
  setIdPermissionList: () => void
  idPermission?: ''
  detailpermission?: DocumentPersonModel
}

const AddDocuments: FC<Props> = ({
  show,
  setShow,
  setIdPermissionList,
  getDocumentPersonList,
  idPermission,
  detailpermission,
}) => {
  const {currentTabItem} = useCentral()
  const [maxLength, setMaxLength] = useState(0)
  const [isEnterprise, setIsEnterprise] = useState<boolean | any>(null)
  const {getEnterpriseSearchOptions, getEnterpriseOptionById} = useEnterpriseService()
  const [empresaSubcontratistaOption, setEmpresaSubcontratistaOption] = useState<{
    value: any
    label: string
  } | null>(null)
  const {statusUser, getStatusUserList, docType, getDocTypeList} = useTableMaster()
  const [loading, setLoading] = useState<boolean>(false)
  const methods = useForm<DocumentPersonModel>({
    resolver: yupResolver(documentByPerson),
    criteriaMode: 'all',
    reValidateMode: 'onChange',
    mode: 'all',
  })
  const {
    setValue,
    setError,
    reset,
    clearErrors,
    watch,
    formState: {errors},
  } = methods
  useEffect(() => {
    return () => {
      clearErrors()
    }
  }, [])
  useEffect(() => {
    if (idPermission) {
      const tipoDocumento = detailpermission?.documento
      setValue('documento.empresaId', tipoDocumento?.empresaId || '')
      setValue('documento.tipoDocumento', tipoDocumento?.tipoDocumento || '')
      setValue('documento.tipoDocumento', tipoDocumento?.tipoDocumento || '')
      setValue('documento.numeroDocumento', tipoDocumento?.numeroDocumento || '')
      setValue('documento.estado', tipoDocumento?.estado || '')
      setValue('documento.docDefault', tipoDocumento?.docDefault || '')
      if (tipoDocumento?.empresaId) {
        setIsEnterprise(true)
        getEnterpriseOptionById(tipoDocumento.empresaId).then(setEmpresaSubcontratistaOption)
      }
    }
  }, [idPermission])

  useEffect(() => {
    if(docType.length > 0 && idPermission){
      const tipoDocumento = docType.find((item) => item.value === watch('documento.tipoDocumento'))
      if (tipoDocumento) {
        setMaxLength(tipoDocumento.maxLength)
      }
    }
  },[docType])

  useEffect(() => {
    getDocTypeList()
    getStatusUserList()
    setValue('documento.estado', 'ACT')
  }, [])

  const handleClose = () => {
    setShow(false)
    reset()
    setIdPermissionList()
    clearErrors()
    setIsEnterprise(null)
    setEmpresaSubcontratistaOption(null)
  }

  const handleGetEmpresaSubcontratista = (val: any) => {
    const value = val ? val : ''
    setValue('documento.empresaId', value.value)
    setError('documento.empresaId', {})
    setEmpresaSubcontratistaOption(val ?? null)
  }

  const loadOptionsEmpresa = useCallback(async (inputValue: string) => {
    if (!inputValue || inputValue.trim().length < ENTERPRISE_SEARCH_MIN_LENGTH) {
      return []
    }
    return getEnterpriseSearchOptions(inputValue.trim())
  }, [])

  const handleGetMaxLength = (val: any) => {
    const value = val ? val : ''
    setMaxLength(value.length)
    setValue('documento.tipoDocumento', value.value)
    setValue('documento.numeroDocumento', '')
    setError('documento.tipoDocumento', {})
    setError('documento.numeroDocumento', {})
  }

  const onSubmit = async (data: DocumentPersonModel) => {
    try {
      setLoading(true)
      const isCreating = !idPermission
      const response = isCreating
        ? await createDocumentByPerson({personaId: currentTabItem.idToEdit, ...data.documento})
        : await updateDocumentByPerson({
            ...data,
            id: idPermission,
            personaId: currentTabItem.idToEdit,
            ...data.documento,
          })
      if (!response.data.error) {
        const messageResponse = isCreating ? SUCCESS_MESSAGE_CREATE : SUCCESS_MESSAGE_UPDATE
        ShowSnackBar(messageResponse)
        handleClose()
        getDocumentPersonList()
      } else {
        ShowSnackBar(response.data.message, 'error')
      }
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  const handleChangeSelect = (e: any) => {
    setIsEnterprise(e.target.checked)
  }
  let text = idPermission ? 'Editar Identificación' : 'Agregar Identificación'
  let typeDocName =
    watch('documento.tipoDocumento') === '00' || watch('documento.tipoDocumento') === '07'
      ? 'alphaNumeric'
      : 'numeric'
  const handleSave = methods.handleSubmit(onSubmit)

  return (
    <ModalComponent
      show={show}
      title={text}
      handleSubmit={handleSave}
      handleClose={handleClose}
      disabledSubmit={loading}
    >
      <FormProvider {...methods}>
        <form>
          <div className='sdx_form card p-0'>
            <div className='row'>
              <div className='col-sm-12 col-lg-6'>
                <SelectWrapper
                  labelText='Tipo de Doc. Id.'
                  name='documento.tipoDocumento'
                  data={docType}
                  onChangeValue={handleGetMaxLength}
                  required
                />
                {errors.documento && 'tipoDocumento' in errors.documento && (
                  <p className='error-message'>
                    {errors.documento.tipoDocumento?.message?.toString()}
                  </p>
                )}
              </div>
              <div className='col-sm-12 col-lg-6'>
                <InputNumberWrapper
                  labelText='Número de Doc. Id.'
                  name='documento.numeroDocumento'
                  textPlaceholder='Escribe el nro de documento'
                  maxLength={maxLength}
                  type={typeDocName}
                  required
                />

                {errors.documento && 'numeroDocumento' in errors.documento && (
                  <p className='error-message'>
                    {errors.documento.numeroDocumento?.message?.toString()}
                  </p>
                )}
              </div>
            </div>
            <hr className='divider' />
            <div className='row'>
              <div className='col-sm-12 col-lg-6 d-flex align-items-center'>
                <label>¿identificación pertenece a empresa?</label>
                <div className='form-check form-check-custom form-check-solid ps-1'>
                  <input
                    className='form-check-input border border-gray-500'
                    type='checkbox'
                    data-kt-check={isEnterprise}
                    data-kt-check-target='#kt_table_users .form-check-input'
                    checked={isEnterprise}
                    onChange={handleChangeSelect}
                  />
                </div>
              </div>
              {isEnterprise && (
                <div className='col-sm-12 col-lg-6'>
                  <SelectAsyncWrapper
                    labelText='Empresa subcontratista'
                    name='documento.empresaId'
                    loadOptions={loadOptionsEmpresa}
                    onChangeValue={handleGetEmpresaSubcontratista}
                    textPlaceholder='Escribe al menos 4 letras...'
                    value={empresaSubcontratistaOption}
                  />
                  {errors.documento && 'empresaId' in errors.documento && (
                    <p className='error-message'>
                      {errors.documento.empresaId?.message?.toString()}
                    </p>
                  )}
                </div>
              )}
              <div className='col-sm-12 col-lg-6'>
                <SelectWrapper
                  labelText='Estado'
                  name='documento.estado'
                  data={statusUser || []}
                  required
                />
                {errors.documento && 'estado' in errors.documento && (
                  <p className='error-message'>{errors.documento.estado?.message?.toString()}</p>
                )}
              </div>
            </div>
          </div>
        </form>{' '}
        {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
      </FormProvider>
    </ModalComponent>
  )
}

export {AddDocuments}
